export default __webpack_public_path__ + "static/media/star_filled.14766773.svg";